import { cn, formatCurrencyValue } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";

import { NumberInput } from "@/components/ui/number-input";

import { confColor } from "@/lib/miscellaneous/confidence-color";
import type { InvoiceModes } from "@/types/utils";

export const AmountField = ({
  id,
  invoiceMode,
  amountConfidence,
  amount,
  fieldType,
  onBlur,
  readOnly = false,
  disabled = false,
  className,
}: {
  id: string;
  invoiceMode: string;
  amountConfidence?: number;
  amount: number;
  fieldType: InvoiceModes;
  onBlur: (value: any) => void;
  readOnly?: boolean | string | React.ReactNode;
  disabled?: boolean | string | React.ReactNode;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}) => {
  const inputRef = useRef<any>(null);
  const [currentValue, setCurrentValue] = useState<number | null>(amount);

  useEffect(() => {
    setCurrentValue(amount);
  }, [amount]);

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      className="flex items-center justify-end"
      onClick={() => inputRef.current?.focus()}
    >
      {invoiceMode === fieldType && !disabled ? (
        <NumberInput
          key={id}
          readOnly={readOnly}
          className={cn(
            "text-right font-normal text-sm rounded bg-transparent border-0 px-2 py-1",
            className,
            confColor(amountConfidence),
          )}
          ref={inputRef}
          value={currentValue}
          // TODO: is this correct?
          // prefix={getSymbolFromCurrency(currency)}
          onChange={(value) => {
            setCurrentValue(value);
          }}
          onBlur={(value) => onBlur(value)}
          onFocus={(e) => {
            e.target.select();
          }}
        />
      ) : (
        <span
          className={cn(
            "font-normal text-sm text-gray-400 px-2 py-1",
            className,
          )}
        >
          {currentValue && formatCurrencyValue(currentValue)}
        </span>
      )}
    </div>
  );
};
